import React from 'react';
import styled from 'styled-components';
import CentredSpinner from '../../../../../../Utility/CenteredSpinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 66px;
  height: 30px;
  cursor: pointer;
  clear: both;
  background: #000;
  border-radius: 28px;
  color: #fff;

  :hover {
    border-color: #000;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  right: 19px;
  top: 10px;
  width: 66px;
  height: 30px;
`;

const Text = styled.span`
  display: flex;
  justify-content: center;
  margin-top: 7px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-family: Basier Circle;
  font-weight: 500;
  font-style: normal;
  line-height: 16px;
  letter-spacing: -0.2 px;
`;

function Done(props) {
  return (
    <React.Fragment>
      {props.isLoading ? (
        <LoadingWrapper>
          <CentredSpinner />
        </LoadingWrapper>
      ) : (
        <Container onClick={props.onClick}>
          <Text>{props.children}Done</Text>
        </Container>
      )}
    </React.Fragment>
  );
}

export default Done;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Done/index.jsx